import * as React from "react";
import { I18nObject, noI18nI18n } from "@spscommerce/ds-shared";

export const I18nContext = React.createContext<I18nObject>(noI18nI18n);
